<template>
  <div
    class="tab-pane fade show active h-100"
    data-view="conference"
    id="pills-conference"
    role="tabpanel"
    aria-labelledby="pills-conference-tab"
  >
    <div v-if="conferenceStore.conferences.length > 0">
      <ConferenceCard
        v-for="conference in conferenceStore.conferences"
        :conference="conference"
        :key="conference.conference_id"
        :agenda="true"
        :school="school"
      ></ConferenceCard>
    </div>
    <div v-else-if="conferenceStore.loading" class="loading-splash">
      <LoadingIcon /><span>Loading Conference data…</span>
    </div>
    <div v-else class="empty-state" data-cy="no-conference-available-state">
      <figure>
        <IconListEmptyState />
      </figure>
      <div class="title">We couldn't find any conferences for you.</div>
      <p>If you have any questions, please contact your school representative.</p>
    </div>
  </div>
</template>

<script setup>
// import { ref } from 'vue';
import { useConferenceStore } from "@/stores/parent/conference";
import ConferenceCard from "./ConferenceCard.vue";
import IconListEmptyState from "@/assets/icons/list-empty-state.svg";
import LoadingIcon from "@/assets/icons/loading.svg";
const conferenceStore = useConferenceStore();

defineProps({
  school: Object
});
</script>
